export const drawerWidth = 250;
export const borderRadiusContainer = "0px";
export const appBarHeight = 60;
